/* 
Common code for each of the levy collection views.
*/
import lookupMixins from "@/mixins/lookup.mixins";
import * as lcAction from "@/store/levy-collections/action-types";

export default {
  mixins: [lookupMixins],
  computed: {
    levyCollectionId() {
      return parseInt(this.$route.params.id);
    },
    levyCollectionDescription() {
      if (!this.lcState.loaded) {
        return "";
      }
      const lc = this.levyCollection;
      return `${lc.year} ${this.lookups.levyCollectionTypeDescriptions[lc.type]}`;
    },
    isSandbox() {
      return this.doesLookupHaveAttribute(this.levyCollection.type, "IsSandbox", this.lookups.levyCollectionTypes);
    },
    statusDescription() {
      return !this.isSandbox ? this.lookups.levyCollectionStatusDescriptions[this.levyCollection.status] : "";
    },
    loading() {
      return this.lcState.loading;
    },
    loaded() {
      return this.lcState.loaded;
    },
    lcState() {
      return this.$store.state.levyCollections.view;
    },
    levyCollection() {
      return this.lcState.data;
    }
  },
  watch: {
    levyCollectionId() {
      this.refreshLevyCollection();
    },
    loaded() {
      this.refreshLevyCollection();
    }
  },
  mounted() {
    this.refreshLevyCollection();
  },
  methods: {
    async refreshLevyCollection() {
      await this.$store.dispatch(lcAction.VIEW_REFRESH, this.levyCollectionId);
      if (this.redirectIfSandbox && this.isSandbox) {
        this.$router.replace(`/levy-collections/${this.levyCollectionId}/sandbox`);
      }
    },
    getBreadcrumbs(name) {
      if (this.loading || !this.levyCollectionDescription) return [{ text: "..." }];
      return [{ text: `${this.levyCollectionDescription}${!this.isSandbox ? " levy collection" : ""} ${name}` }];
    }
  }
};
